import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CFormCheck,
		CButton,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CFormTextarea,
	CBadge,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogformconsent,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 	= require('../../package.json')
const Consent	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingob 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingob.jml_mobile || 50) : 100;
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword") || "{}");
	const uTokenObj					= JSON.parse(localStorage.getItem("token") || "{}");
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const uDatacabangArr			= JSON.parse(localStorage.getItem("cabanglist")||"[]");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const uJenisconsentArr			= useSelector(state => state.gJenisconsentArr);
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 			= uHeaderActionObj.isHeaderTambah || false;
	const uFilterObj				= uKeywordObj.kwd_consentobj||{};
	const uFrameExport 				= document.getElementById("ifmcontentstoprint");

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselectidx,setRowselectidx]= React.useState(-1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	//const [uDatadokterArr,setDatadokterArr]= React.useState([]);
	//--END VIEWS_VARS--/

	//--PAGE_DIATUR_BACKEND--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const uISInitbefore 				= (JSON.stringify(uLastinitObj||{})!=="{}");
	const [uISBeforeprocess,setISBeforeprocess] = React.useState(false);
	//--END PAGE_DIATUR_BACKEND--*/

	//--DLGFORMCONSENT--/
	const [uISDlgformconsentshow,setDlgformconsentshow]	= React.useState(false);
	const [uDlgformconsentObj,setDlgformconsentObj]		= React.useState({});
	//--END DLGFORMCONSENT--/

	//--DLGLOOKUP--/
	//--END DLGLOOKUP--/

	//--DLGLOOKUP--/
	//--END DLGLOOKUP--/

	//--DLGVIEW--/
	//--END DLGVIEW--/

	//--DOM_VARS--/
	const uElJmlData			= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikCetak = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vRowidx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselectidx(vRowidx);

		if((uDatamainArr[vArridx].status_loaddetil||"TIDAK")==="YA") {
			prosesCetakconsent(_IDTABEL);
			return;
		}

		apiLoaddetil(_IDTABEL);
	}
	const hdlKlikEdit = (_IDTABEL) => {}//--TIDAK_DIPAKAI--/
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vRowidx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselectidx(vRowidx);
		
		const vCaptionupper = (uDatamainArr[vArridx].nama_pasien||"").toUpperCase();

		if(await Konfirm(
			"<p>Hapus Data Consent: <b>"+vCaptionupper+"</b></p>"+
			"<p class='mx-3 fst-italic classfontsmaller'>PERHATIAN: Proses Hapus Membuat Data Consent Tidak Dapat Dikembalikan dan Dibatalkan..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) apiProseshapus(_IDTABEL);
	}
	/*const hdlKDownPasienlookup = (_EV) => {
		setDlgformdataObj({...uDlgformdataObj,id_pasien:0});

		if(_EV.keyCode !== 13) return;
		const vLookuplabel = (uDlgformdataObj.nama_pasien||"").trim();

		if(vLookuplabel === "") return;

		_EV.preventDefault()
		_EV.stopPropagation();

		setDlglookupapiObj({
			dlg_header: "Lookup: Pasien",
			dlg_input: (uDlgformdataObj.nama_pasien||""),
			url_target: pjson.homepage+"api/api_pasien/ld_lookupapi",
			is_kdowntrigger: true,
		});

		setDlglookupapishow(true);
	}
	const hdlKlikPasienlookup = () => {
		setDlglookupapiObj({
			dlg_header: "Lookup: Pasien",
			dlg_input: (uDlgformdataObj.nama_pasien||""),
			url_target: pjson.homepage+"api/api_pasien/ld_lookupapi",
		});
		setDlglookupapishow(true);
	}
	const hdlKDownDokterlookup = (_EV) => {
		setDlgformdataObj({...uDlgformdataObj,id_dokter:0});

		if(_EV.keyCode !== 13) return;
		const vLookuplabel = (uDlgformdataObj.nama_dokter||"").trim(); 
		if(vLookuplabel === "") return;

		_EV.preventDefault()
		_EV.stopPropagation();

		const vArrCariMaster 	= uDatadokterArr.filter((vItems)=>
			vItems.dokter_caption.toUpperCase().includes(vLookuplabel.toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			setDlgformdataObj({...uDlgformdataObj,
				nama_dokter: vArrCariMaster[0].dokter_caption||"",
				id_dokter: parseInt(vArrCariMaster[0].id)
			});

			const vElfocus = document.getElementById("btnDialogSimpan");
			vElfocus && vElfocus.focus();
			return;
		}

		hdlKlikDokterlookup();
	}
	const hdlKlikDokterlookup = () => {
		setDlglookupdataObj({
			dlg_header: "Lookup: Nama Dokter",
			dlg_input: (uDlgformdataObj.nama_dokter||""),
			data_arr: uDatadokterArr.map(vItems=>{
				return {
					id: parseInt(vItems.id)||0,
					caption: vItems.dokter_caption,
				}
			}),
		});
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM 		= parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM);
		setDlgformdataObj({...uDlgformdataObj,
			nama_dokter: uDatadokterArr[vArridx].dokter_caption||"",
			id_dokter: parseInt(uDatadokterArr[vArridx].id),
		});

		setDlglookupshow(false);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElfocus = document.getElementById("btnDialogSimpan");
			vElfocus && vElfocus.focus();
		},500);
	}
	const hdlKlikDlglookupapipilih = (_SELECTEDSTR) => {
		_SELECTEDSTR = _SELECTEDSTR||"{}";
		//if(_SELECTEDSTR==="" || _SELECTEDSTR === "{}") return;
		const vLookupObj	= JSON.parse(_SELECTEDSTR);
		if(vLookupObj==={}) return;

		setDlgformdataObj({...uDlgformdataObj,
			nama_pasien: vLookupObj.caption,
			id_pasien: vLookupObj.id || 0,
		})

		setDlglookupapishow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			const vElfocus	= document.getElementById("inpformdokternama");
			vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikDlgsimpan = () => {//--TIDAK_DIPAKAI--/
		//--VALIDASI--/
		let vElfocus	= document.getElementById("inpformjenisconsentid");
		if((parseInt(uDlgformdataObj.jenis_id)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Jenis Consent Harus Dipilih Terlebih Dahulu !")
			return;
		}
		vElfocus	= document.getElementById("inpformpasiennama");
		if((parseInt(uDlgformdataObj.id_pasien)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("NAMA PASIEN Harus Dipilih Dengan Benar !")
			return;
		}
		vElfocus	= document.getElementById("inpformdokternama");
		if((parseInt(uDlgformdataObj.id_dokter)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("NAMA DOKTER Harus Dipilih Dengan Benar !")
			return;
		}
		//--END VALIDASI--/

		//--EXECUTE_PROCESS--/
		const vNamaform	= "formconsent_"+uDlgformdataObj.jenis_id;
		const vTmpObj	= { ...uDlgformdataObj,dlg_header:undefined }
		uDispatch({type: "set", gConsentcreateObj: vTmpObj});

		uNavigate("/subpasien/pasien/"+vNamaform+"/0");
		//--END EXECUTE_PROCESS--/
	}//-*/
	//--END HANDEL--/

	//--INIT_FUNC--/
	const prosesCetakconsent = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vContent	= uDatamainArr[vArridx].content_html || "";
		if(vContent === "") return;

		uFrameExport.srcdoc = vContent;
		uFrameExport.onload = function() {
			uFrameExport.contentWindow.focus();
			uFrameExport.contentWindow.print();
		};
	}
	//--END INIT_FUNC--/

	//--CONTENT_FUNC--/
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uFilterObj.kwd_consent || "");
		const vKeywordcolor = uSettingob.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		/*//--PAGE_DIATUR_FRONTEND--/
		const vDataviewArr	= isMobile 
			? uDatamainArr.slice(0,vMax) : uDatamainArr.slice(vMin,vMax);
		//--END PAGE_DIATUR_FRONTEND--*/

		//--PAGE_DIATUR_BACKEND--/
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.pg||1) === parseInt(uPageActive));
		//--END PAGE_DIATUR_BACKEND--*/
		
		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={30} className="px-0"><small>No</small></th>
			<th className="px-0">
			<CRow className="mx-0">
			<CCol md="2" className="text-start px-0"><small>{uBahasaObj.caption_tglconsent||"Tgl Consent"}</small></CCol>
			<CCol md="4" className="text-start px-0"><small>{uBahasaObj.caption_Jenis||"Jenis Consent"}</small></CCol>
			<CCol md="3" className="text-start px-0"><small>{uBahasaObj.word_pasien||"Pasien"}</small></CCol>
			<CCol md="2" className="text-start px-0"><small>{uBahasaObj.word_dokter||"Dokter"}</small></CCol>
			<CCol md="1" className="px-0">&middot;</CCol>
			</CRow>
			</th>
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				tgl_consent,id_cabang,nama_cabang,id_jenis_consent,
				titel_jenis_consent,nama_tindakan,id_dokter,nama_dokter,
				id_pasien,nama_pasien,umur_pasien,sex_pasien,
				tgl_input, user_input,is_loading,
				id,
			} = vItems;

			vNumber++;
			const vCaptionupper	= (nama_pasien||"").toUpperCase();

			const vPasiencaption	= vKeyword==="" ? (nama_pasien||"UNDF Pasien") 
				: (nama_pasien||"UNDF Pasien").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vTitelcaption	= vKeyword==="" ? (titel_jenis_consent||"UNDF Consent") 
				: (titel_jenis_consent||"UNDF Consent").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vTindakannama	= vKeyword==="" ? (nama_tindakan||"UNDF Tindakan") 
				: (nama_tindakan||"UNDF Tindakan").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vDoktercaption	= vKeyword==="" ? UFunc.Usercaptionfilter((nama_dokter||"UNDF Dokter")) 
				: UFunc.Usercaptionfilter((nama_dokter||"UNDF Dokter")).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vTglconsent	= vKeyword==="" ? UFunc.TglAngka(tgl_consent) 
				: UFunc.TglAngka(tgl_consent).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vTglinput	= vKeyword==="" ? UFunc.WaktuAngka(tgl_input) 
				: UFunc.WaktuAngka(tgl_input).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vUserinput	= vKeyword==="" ? UFunc.Usercaptionfilter(user_input,2) 
				: UFunc.Usercaptionfilter(user_input,2).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselectidx===vKeys?" classrowselect":"")}>
			<td className="px-1">{vNumber}.</td>

			<td className="px-1 px-md-0">
			<CRow className="mx-0">
				<CCol md="2" className="text-md-start px-1 d-none d-md-block">
					<div>{UFunc.renderHTML(vTglconsent)}</div>
					<div className="classfontsmaller text-danger"><small>[
						{UFunc.renderHTML(vUserinput)}
					]</small></div>
				</CCol>

				<CCol md="4" className="text-start px-1">
					<div className="d-flex justify-content-between align-items-start">
					<div>
						<div className="fw-bolder">{UFunc.renderHTML(vTitelcaption)}</div>
						<small className="text-primary fst-italic">{UFunc.renderHTML(vTindakannama)}</small>
					</div>

					<CDropdown className="d-md-none">
						<CDropdownToggle caret={false} color="transparent" className="p-0">
							<CIcon icon="cilChevronBottom" className="classikonbox align-middle" height={23}/>
						</CDropdownToggle>

						<CDropdownMenu>
						<CDropdownItem onClick={()=>hdlKlikCetak(id)}>
						<CIcon className="classikoncetak align-middle mx-0 me-1" height={25}/>CETAK-PDF Consent
						</CDropdownItem>

						{(uISHapusallow) && (
						<>
						{(1===3) && (
						<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
						<CIcon className="classikonedit align-middle mx-0 me-1" height={25}/>Edit Consent
						</CDropdownItem>
						)}

						<CDropdownDivider/>

						<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
						<CIcon className="classikonhapus align-middle mx-0 me-1" height={25}/>Hapus Consent
						</CDropdownItem>
						</>
						)}
						</CDropdownMenu>
					</CDropdown>
					</div>
				</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="4" className="text-start px-1 d-md-none"><small>Tgl Consent</small></CCol>
				<CCol xs="8" className="px-1 d-md-none">{UFunc.renderHTML(vTglconsent)}</CCol>

				<CCol xs="4" className="text-start px-1 d-md-none"><small>Dokter</small></CCol>
				<CCol xs="8" className="px-1 d-md-none">{UFunc.renderHTML(vDoktercaption)}</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="4" className="text-start px-1 d-md-none"><small>Nama Pasien</small></CCol>
				<CCol xs="8" md="3" className="text-md-start px-1">
					<div className="text-info">{UFunc.renderHTML(vPasiencaption)}</div>
					<small className="d-none d-md-block">
						{umur_pasien} th
						<span> &middot; </span>
						<b>[{sex_pasien}]</b>
					</small>
				</CCol>

				<CCol xs="5" className="text-start px-1 d-md-none"><small>Umur</small></CCol>
				<CCol xs="7" md="3" className="px-1 d-md-none">
					<small>
						{umur_pasien||0} th
						<span> &middot; </span>
						<b>[{sex_pasien||"L"}]</b>
					</small>
				</CCol>

				<CCol md="2" className="text-md-start px-1 d-none d-md-block">{UFunc.renderHTML(vDoktercaption)}</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="5" className="text-start px-1 d-md-none"><small>Inputby</small></CCol>
				<CCol xs="7" className="px-1 d-md-none classfontsmaller text-danger">
					<small>[
						{UFunc.renderHTML(vUserinput)}
					]</small>
				</CCol>

				<CCol md="1" className="px-0 text-md-center d-none d-md-block">
					{(is_loading||false)===true ? (
						<CSpinner color="primary" size="sm"/>
					) : (
					<>
						<CTooltip content="--CETAK-PDF Consent">
						<CLink onClick={()=>hdlKlikCetak(id)} className="classcursorpointer classikontabel classikoncetak px-0"/>
						</CTooltip>

						{(uISHapusallow) && (
						<CDropdown>
						<CDropdownToggle caret={false} color="transparent" className="p-0 m-0">
							<CIcon icon="cilChevronBottom" className="classikonbox align-middle mx-0 ms-lg-1" height={23}/>
						</CDropdownToggle>

						<CDropdownMenu>
						{(1===3) && (
						<>
						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikEdit(id)}>
						<CIcon className="classikonedit align-middle mx-0 me-1" height={25}/>Edit Consent
						</CDropdownItem>

						<CDropdownDivider/>
						</>
						)}

						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikHapus(id)}>
						<CIcon className="classikonhapus align-middle mx-0 me-1" height={25}/>Hapus Consent
						</CDropdownItem>
						</CDropdownMenu>
						</CDropdown>
						)}
					</>
					)}
				</CCol>
			</CRow>
			</td>
			</tr>
			)//>
		})}
		</tbody>
		</table>
		)//>
	}
	//--END CONTENT_FUNC--/

	//--API--/
	const apiLoadawal = async() => { 
		setHtml500msg();
		setDatamainArr([]);
		setLoading(true);
		try {
			setSessionaktif(false);
			const vPage			= uLastinitObj ? parseInt(uLastinitObj.initPage||1) : 1;
			const vKeyword 		= (uFilterObj.kwd_consent || "").trim();
			const vCabangid		= parseInt(uFilterObj.cabang_id||uTokenObj.user_cabangid);
			const vHeaderObj = {
				headers: { Accept: "application/json", "Content-Type": "application/json" },
				method: "POST",
				mode: "cors",
				cache: "default",
			}

			setPageActive(vPage);

			setTimeelapse(0);
			const vTimeBegin = new Date();
			const [output_main] = await Promise.all([
				(async () => {
					const vURLs	= pjson.homepage+"api/api_consent/ld_data";
					const vDATAS= JSON.stringify({
						send_cabangid: vCabangid,
						send_keyword : vKeyword,
						send_page: vPage,
						send_jmlperpage: uMaxData,
						send_loadjml: "YA",
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
				
				(async () => {
					const vURLs	= pjson.homepage+"api/api_dokter/ld_dokterlookup";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
			]);

			setSessionaktif(true);
			//--DATA_MAIN--/
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setTimeelapse(vTimeDiff);
			if(output_main.tampil) {
				//console.log("(Consent - apiLoadawal) output_main.dataobject : "+(output_main.dataobject));
				const vTmpArr = JSON.parse(output_main.dataobject||"[]");

				//--PAGE_DIATUR_BACKEND--/
				vTmpArr.map(vItems=>vItems.pg = vPage);
				setDatamainArr([...vTmpArr]);

				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_main.totaldata||uJmlData))
				else setJmlData(vTmpArr.length);

		    	if(uISInitbefore) setISBeforeprocess(true);
				//--END PAGE_DIATUR_BACKEND--*/

				/*//--PAGE_DIATUR_FRONTEND--/
				setDatamainArr(vTmpArr);
				//--END PAGE_DIATUR_FRONTEND--*/
			} else if(output_main.info) {
				setHtml500msg(output_main.info);
			} else if(output_main.errors) {
				console.log("(Consent - apiLoadawal) output_main.errors : "+output_main.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_main.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_main.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DATA_MAIN--/
		} catch (error) {
			console.log("(Consent - apiLoadawal) catch-error : "+error.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			setLoading(false);
		}
	}
	const apiLoaddata = (_PAGE) => {
		const vPage	= parseInt(_PAGE)||1;
		setHtml500msg();

		const vKeyword 		= (uFilterObj.kwd_consent || "").trim();
		const vCabangid		= parseInt(uFilterObj.cabang_id||uTokenObj.user_cabangid);

		//--PAGE_DIATUR_BACKEND--/
		let vDatamainArr	= uDatamainArr;
		if(vKeyword.length < 3) {
			vDatamainArr 	= []
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.pg||1) === 1);
			} else
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.pg||1) !== uPageActive);
		}
		//--END PAGE_DIATUR_BACKEND--*/

		/*//--PAGE_DIATUR_FRONTEND--/
		setDatamainArr([]);
		setJmlData(0);
		setRowselectidx(-1);
		setPageActive(1);
		//--PAGE_DIATUR_FRONTEND--*/

		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid: vCabangid,
			send_keyword : vKeyword,
			send_page: vPage,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}" || !_PAGE) ? "YA" : "TIDAK",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Consent - apiLoaddata) uPageActive : "+(uPageActive));
				const vTmpArr = JSON.parse(output_string.dataobject||"[]");

				//--PAGE_DIATUR_BACKEND--/
				vTmpArr.map(vItems=>vItems.pg = vPage);
				setDatamainArr([...vDatamainArr,...vTmpArr]);

				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.totaldata||uJmlData))
				else setJmlData(vTmpArr.length);

		    	if(uISInitbefore) setISBeforeprocess(true);
				//--END PAGE_DIATUR_BACKEND--*/

				/*//--PAGE_DIATUR_FRONTEND--/
				setDatamainArr(vTmpArr);
				//--END PAGE_DIATUR_FRONTEND--*/

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Consent - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Consent - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoaddetil = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
			is_loading: true,
		}

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/ld_detil";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.tampil) {
				const vContenthtml 	= output_string.contenthtml_str || "";
				const vTmpurlArr	= JSON.parse(output_string.urlimgarr_str || "[]");

				uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
					is_loading: false,
					status_loaddetil: "YA",
					content_html: vContenthtml,
				}
				//console.log("(Consent - apiLoaddetil) vTmpurlArr : ",vTmpurlArr);

				//--CACHING_IMG--/
				Promise.all(vTmpurlArr.map(src => {
					const img = new Image();
					img.src = src;
					return img.decode();
				})).finally(() => prosesCetakconsent(_IDTABEL) );
				//--END CACHING_IMG--/
			} else {
				uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
					is_loading: false,
				}
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Consent - apiLoaddetil) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
				is_loading: false,
			}
			console.log("(Consent - apiLoaddetil) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
			is_loading: true,
		}
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.sukses) {
				uDatamainArr.splice(vArridx,1);
				setLoading(false);
			} else {
				uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
					is_loading: false,
				}
				setLoading(false);
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Consent - apiProseshapus) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
				is_loading: false,
			}
			setLoading(false);
			console.log("(Consent - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		uDispatch({type: "set", gConsentcreateObj: undefined});

		apiLoadawal();

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
    		setDatamainArr([]); setJmlData(0); setRowselectidx(-1); setPageActive(0);
    		setISBeforeprocess(false);
			setDlgformconsentshow(false);
			//setDlglookupshow(false);setDlglookupapishow(false);
    	}
	},[]);
	React.useEffect(()=>{
		if(!uISInitbefore) return;

		const vPageinit	= parseInt(uLastinitObj.initPage)||1;
		setPageActive(vPageinit); apiLoaddata(vPageinit);
	},[uISInitbefore]);
	React.useEffect(()=>{
		if(!uISBeforeprocess) return;

		const vInitID	= uLastinitObj.initID;
		
		const vElscroll	= document.getElementById("idtr"+(vInitID||0));
		const vRectdimensi = vElscroll && (vElscroll.getBoundingClientRect());
		vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		//console.log("(Requestorder - [uLastinitObj]) vRectdimensi => "+JSON.stringify(vRectdimensi))

		setISBeforeprocess(false)
		uDispatch({type: "set", gInitTabelSelected: {}}); 
	},[uISBeforeprocess]);
	React.useEffect(()=>{ 
		setRowselectidx(-1); 

		//--PAGE_DIATUR_BACKEND--/
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		const vDataviewArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoaddata(uPageActive);
		//--END PAGE_DIATUR_BACKEND--*/
	},[uPageActive])
	/*//--PAGE_DIATUR_FRONTEND--/
	React.useEffect(()=>{ setJmlData(uDatamainArr.length); },[uDatamainArr.length])
	//--END PAGE_DIATUR_FRONTEND--*/
	React.useEffect(()=>{ 
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);

		//--PAGE_DIATUR_BACKEND--/
		const vKeyword 		= uFilterObj.kwd_consent || "";
		if(vKeyword.length < 3) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}
		//--END PAGE_DIATUR_BACKEND--*/

		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uElJmlData,uJmlData])
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		//--PAGE_DIATUR_BACKEND--/
		setDatamainArr([]);
		setJmlData(0);
		setRowselectidx(-1);

		if(parseInt(uPageActive) !== 1) {
			setPageActive(1);
		} else apiLoaddata();
		//--END PAGE_DIATUR_BACKEND--*/

		/*//--PAGE_DIATUR_FRONTEND--/
		apiLoaddata();
		//--END PAGE_DIATUR_FRONTEND--*/
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setRowselectidx(-1);
		if(uHtml500msg) return;

		setDlgformconsentObj({
			id_cabang: parseInt(uTokenObj.user_cabangid)||0,
			id_dokter: uTokenObj.userhak==="DOKTER" && parseInt(uTokenObj.user_dokterid),
		})
		setDlgformconsentshow(true);
	},[uHandelTambah])
	React.useEffect(()=>{
		if(!uISDlgformconsentshow) 
			{ setDlgformconsentObj({}); return }
	},[uISDlgformconsentshow]);

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<strong>{uBahasaObj.caption_page500||"Page 500"}</strong>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)//>

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center">
		<div>
		<b className="align-middle">{uBahasaObj.caption_listdata||"List Data"}</b>
		<span className="mx-1 d-md-none">&middot;</span>
		<small className="d-md-none text-primary align-middle">{(()=>{
			const vKeyword = (uFilterObj.kwd_consent||"").trim();
			if(vKeyword.length < 3) return (<>&#8734;</>);

			return (<>[{UFunc.formatAngka(uJmlData)}]</>)
		})()}</small>
		</div>
		<span className="text-muted classfontsmaller">
			<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
		</span>
		<small className="d-none">({uJmlData} - {uMaxData})</small>
		</CCardHeader>
		
		<CCardBody className="px-0">
			{contentMain()}
		</CCardBody>

		{(uJmlData > uMaxData) && (
		<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/> 
		</CCardFooter>
		)}
		</CCard>

		<MyDialogformconsent
			show={uISDlgformconsentshow} 
			toggle={()=>setDlgformconsentshow(false)}
			cabangid={uDlgformconsentObj.id_cabang}
			dokterid={uDlgformconsentObj.id_dokter}
			{...props}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		</>
	)//>
}	

export default Consent